import React, { useDebugValue } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
} from "reactstrap";

function Tables() {
  const [orders, setOrders] = React.useState([]);
  const admin = useSelector((state) => state.admin);

  React.useEffect(() => {
    getUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getUsers = async () => {
    try {
      const response = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}/orders?page=1`,
        headers: { Authorization: `Bearer ${admin.token}` },
      });

      response && setOrders(response.data);
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  async function handleSelect(orderId, value) {
    console.log(value);

    console.log(orderId);
    try {
      await axios({
        method: "PATCH",
        url: `${process.env.REACT_APP_API_URL}/orders/${orderId}`,
        headers: { Authorization: `Bearer ${admin.token}` },
        data: { statusNum: value },
      });
    } catch (error) {
      console.log("Error: ", error);
    }
  }

  const statusList = [
    "En revisión",
    "Pagado",
    "Enviado",
    "Recibido",
    "Abortado",
  ];

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card className="card-plain">
              <CardHeader>
                <CardTitle tag="h4">Orders List</CardTitle>
              </CardHeader>

              <CardBody>
                <Table responsive className="bg-white">
                  <thead className="text-primary">
                    <tr>
                      <th className="border">Customer info</th>
                      <th className="border">Total Price</th>
                      <th className="border">Products</th>
                      <th className="border">Start date</th>
                      <th className="border">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders &&
                      orders.map((order) => (
                        <tr key={order._id}>
                          <td>
                            <ul>
                              {" "}
                              <li>
                                {" "}
                                user name: {order.user.firstname}
                                {"   "}
                                {order.user.lastname}
                              </li>
                              <li> phone number: {order.user.phoneNumber}</li>
                            </ul>
                          </td>
                          <td>${order.totalPrice}</td>
                          <td>
                            {" "}
                            {order.products.map((product) => (
                              <p> {product.name}</p>
                            ))}
                          </td>
                          <td>
                            <p className="m-0">
                              {order.createdAt.split("T")[0]}
                            </p>{" "}
                            <p className="m-0">
                              {order.createdAt.split("T")[1].split(".")[0]} Hs
                            </p>
                          </td>
                          <td>
                            <select
                              style={{ width: "70%" }}
                              className="border-0 bg-white"
                              defaultValue={statusList.indexOf(order.status)}
                              onChange={(e) =>
                                handleSelect(order._id, e.target.value)
                              }
                            >
                              <option value={0}>En revisión</option>
                              <option value={1}>Pagado</option>
                              <option value={2}>Enviado</option>
                              <option value={3}>Recibido</option>
                              <option value={4}>Abortado</option>
                            </select>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Tables;
